export default __webpack_public_path__ + "static/zencastr-4bafc1728e3e5c2afba4eae6cdf50a70.png";